const frequency = Object.freeze({
    day: 1,
    week: 2,
    month: 3,
    year: 4
});

export default frequency;
